import styled from 'styled-components';

import { COLORS } from '@summer/ui-components';

/**
 * @param {'default'|'success'|'error'|'warning'|'neutral'} variant
 * @returns {string}
 */
const getVariantStyles = (variant: any) => {
  switch (variant) {
    case 'success':
      return `
        background-color: #f2fdfa;
        border: 1px solid #0e8273;
        color: #0e8273;
      `;
    case 'error':
      return `
        background-color: #fef2f2;
        border: 1px solid #dc2626;
        color: #dc2626;
      `;
    case 'warning':
      return `
        background-color: #fffdf5;
        border: 1px solid #f59e0b;
        color: #f59e0b; 
      `;
    case 'neutral':
      return `
        background-color: #f9fafb;
        border: 1px solid #6b7280;
        color: #6b7280;
      `;
    case 'default':
    default:
      return `
        background-color: ${COLORS.azure};
        border: 1px solid ${COLORS.azure};
        color: white;
      `;
  }
};

const StyledBadge = styled.div<any>`
  display: inline-flex;
  align-items: center;
  border-radius: 10px;
  padding: 2px 5px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  ${(props: any) => getVariantStyles(props.variant)}
`;

/**
 * @typedef {'default' | 'success' | 'error' | 'warning' | 'neutral'} BadgeVariant
 * @param {{ variant: BadgeVariant; children: React.ReactNode } & React.ComponentProps<'div'>} props
 */
const Badge = ({ variant = 'default', children, ...props }: any) => {
  return (
    <StyledBadge variant={variant} aria-label={`${variant} badge`} {...props}>
      {children}
    </StyledBadge>
  );
};

export default Badge;
